const e = {
  name: "Filter",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,0h40v7.4l-16,16v11L18.4,40H16V23.4L0,7.4V0z M2,2v4.6l16,16v15l4-4v-11l16-16V2H2z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Filter
};
